<template>
  <v-card
    ref="filter"
    class="card"
    v-hammer:pan="dragFilter"
    v-hammer:panend="dragEndFilter"
    :style="[computedFilterY, computedFilterX, computedWidth]"
  >
    <v-card-title class="pb-4">
      <span>Фильтр</span>
      <v-spacer></v-spacer>
      <v-icon color="lightGrey" class="mr-1 close-btn" size="22" title="Закрыть" @click="close">
        mdi-close
      </v-icon>
    </v-card-title>

    <v-card-text class="pt-3 filter border-top">
      <v-row class="pt-4">
        <v-col cols="12" class="py-0">
          <v-autocomplete
            class="pa-0"
            v-model="localVacancyFilter.courseNumber"
            :items="dictionaries.courseNumber" item-text="name"
            label="Номер курса" placeholder="Выберите из списка"
            dense clearable return-object outlined rounded
            @change="search"
          />
        </v-col>

        <v-col cols="12" class="py-0">
          <v-autocomplete
            class="pa-0"
            v-model="localVacancyFilter.speciality"
            :items="dictionaries.speciality" item-text="name"
            label="Специальность" placeholder="Выберите из списка"
            dense clearable return-object outlined rounded
            @change="search"
          />
        </v-col>

        <v-col cols="12" class="py-0">
          <v-autocomplete
            class="pa-0"
            v-model="localVacancyFilter.paidForm"
            :items="dictionaries.paidForm" item-text="name"
            label="Платная форма" placeholder="Выберите из списка"
            dense clearable return-object outlined rounded
            @change="search"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="pt-0">
      <v-spacer></v-spacer>
      <v-btn text color="lightGrey" @click="reset" :disabled="disabledBtn">Сбросить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep"
import { VacancyFilter } from "@/models"
import { mapGetters } from "vuex"

export default {
  name: "ContestFilterDialog",

  props: {
    vacancyFilter: Object,
    widthFilter: {
      type: [String, Number],
      default: 300
    },
    top: {
      type: [String, Number],
      default: 0
    },
    left: {
      type: [String, Number],
      default: 0
    },
    right: [String, Number],
    bottom: [String, Number],
  },

  async created() {
    this.setPropsPosition()
  },

  mounted() {
    window.addEventListener("resize", this.fixPositionFilterInResize)
  },

  destroyed() {
    window.removeEventListener("resize", this.fixPositionFilterInResize)
  },

  data() {
    return {
      localVacancyFilter: new VacancyFilter(),

      disabledBtn: false,

      filterPosition: {
        X: 0,
        Y: 0,
        lastX: 0,
        lastY: 0,
        maxX: 0,
        minX: 0,
        maxY: 0,
        minY: 0
      },
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['dictionaries']),

    computedWidth() {
      return { width: `${this.widthFilter}px` }
    },

    computedFilterY() {
      return this.bottom ? { bottom: `${this.filterPosition.Y}px` } : { top: `${this.filterPosition.Y}px` }
    },

    computedFilterX() {
      return this.right ? { right:`${this.filterPosition.X}px` } : { left:`${this.filterPosition.X}px` }
    }
  },

  methods: {
    dragFilter(event) {
      this.$refs.filter.$children.forEach(item => item.hasOwnProperty('blur') && item.blur())

      this.right ?
        this.filterPosition.X = this.filterPosition.lastX - event.deltaX :
        this.filterPosition.X = this.filterPosition.lastX + event.deltaX

      this.bottom ?
        this.filterPosition.Y = this.filterPosition.lastY - event.deltaY :
        this.filterPosition.Y = this.filterPosition.lastY + event.deltaY

      this.filterPosition.maxX = window.innerWidth - this.$refs.filter.$el.clientWidth
      this.filterPosition.minX = 0

      this.filterPosition.maxY = window.innerHeight - this.$refs.filter.$el.clientHeight
      this.filterPosition.minY = 0

      if (this.filterPosition.X > this.filterPosition.maxX) this.filterPosition.X = this.filterPosition.maxX
      if (this.filterPosition.X < this.filterPosition.minX) this.filterPosition.X = this.filterPosition.minX
      if (this.filterPosition.Y > this.filterPosition.maxY) this.filterPosition.Y = this.filterPosition.maxY
      if (this.filterPosition.Y < this.filterPosition.minY) this.filterPosition.Y = this.filterPosition.minY
    },

    dragEndFilter() {
      this.filterPosition.lastX = this.filterPosition.X
      this.filterPosition.lastY = this.filterPosition.Y
    },

    setPropsPosition() {
      if (this.bottom) {
        this.filterPosition.Y = +this.bottom
        this.filterPosition.lastY = +this.bottom
      } else {
        this.filterPosition.Y = +this.top
        this.filterPosition.lastY = +this.top
      }
      if (this.right) {
        this.filterPosition.X = +this.right
        this.filterPosition.lastX = +this.right
      } else {
        this.filterPosition.X = +this.left
        this.filterPosition.lastX = +this.left
      }
    },

    fixPositionFilterInResize() {
      // if (this.right && this.filterPosition.X > window.innerWidth - +this.widthFilter) {
      //   this.filterPosition.X = window.innerWidth - +this.widthFilter
      //   this.filterPosition.lastX = window.innerWidth - +this.widthFilter
      // }

      if (this.right && this.$refs.filter.$el.getBoundingClientRect().left <= 0) {
        this.filterPosition.X += this.$refs.filter.$el.getBoundingClientRect().left
        this.filterPosition.lastX += this.$refs.filter.$el.getBoundingClientRect().left
      }

      if (this.left && this.$refs.filter.$el.getBoundingClientRect().right >= window.innerWidth) {
        this.filterPosition.X = window.innerWidth - +this.widthFilter
        this.filterPosition.lastX = window.innerWidth - +this.widthFilter
      }

      if (this.bottom && this.$refs.filter.$el.getBoundingClientRect().top <= 0) {
        this.filterPosition.Y += this.$refs.filter.$el.getBoundingClientRect().top
        this.filterPosition.lastY += this.$refs.filter.$el.getBoundingClientRect().top
      }

      if (this.top && this.$refs.filter.$el.getBoundingClientRect().bottom >= window.innerHeight) {
        this.filterPosition.Y = window.innerHeight - this.$refs.filter.$el.clientHeight
        this.filterPosition.lastY = window.innerHeight - this.$refs.filter.$el.clientHeight
      }
    },

    close() {
      this.$emit('closeFilter')
    },

    search() {
      this.$emit('applyFilter', this.localVacancyFilter)
    },

    reset() {
      this.disabledBtn = true
      this.$emit('applyFilter')
      setTimeout(() => this.disabledBtn = false, 1000)
    }
  },

  watch: {
    vacancyFilter: {
      immediate: true,
      deep: true,
      handler(value) {
        this.localVacancyFilter = _cloneDeep(value)
      },
    }
  }
}
</script>

<style scoped>
.card {
  position: fixed;
  z-index: 1000;
  border-radius: 20px !important;
}

.select >>> .v-text-field__details {
  display: none;
}

.close-btn:hover {
  color: #e01a1a !important
}

.filter >>> input[type=text], .filter >>> .v-select__selections {
  font-size: .8125rem;
  font-weight: 500;
}

.filter >>> .v-label {
  font-size: 14px;
}

.filter >>> .v-text-field__details {
  display: none;
}

.filter >>> .v-input__control {
  margin-top: 2px;
}

.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
